<template>
  <div class="player-rank">
    <h2 class="section-title">{{section}}</h2>
    <div class="section-content">
      <div class="section-left">
        <img :src="playerImg" :alt="playerImgAlt" />
      </div>
      <!-- ol 사용하지 않은 이유: ol로 출력되는 숫자를 컨트롤 할 수 없어서, 공동 1위 공동 2위도 존재 할 수 있음 -->
      <div class="section-right">
        <ul class="player-rank-list">
          <!-- 1위인 경우에는 rank1 클래스를 추가해야 합니다. -->
          <li v-for="(player, index) in rankList" :key="'player_rank_' + section + player.rank + '_' + index"
              :class="player.rank === '1' ? 'rank1' : ''">
            <div class="left-area">
              <span>{{player.rank}}</span>
              <span>{{player.team}}</span>
              <span class="player-name">{{player.name}}</span>
            </div>
            <div class="right-area">
              <span class="player-value">{{player.value}}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
export default {
  name: 'PlayerRank',
  props: {
    rankList: {
      type: Array
    },
    section: {
      type: String
    }
  },
  data () {
    return {
      placeholderImage: require('../../assets/images/common/kbo_player_rank_img_default_thum.svg')
    }
  },
  computed: {
    playerImg () {
      const playerImage = _.get(this.rankList, '0.image', '')
      return playerImage !== '' ? playerImage : this.placeholderImage
    },
    playerImgAlt () {
      return _.get(this.rankList, '0.name', '')
    }
  }
}
</script>
